/* eslint-disable */
import React, { useState, useEffect } from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Stack, Card } from '@material-ui/core';
import TablePagination from '@mui/material/TablePagination';
import TableSortLabel from '@material-ui/core/TableSortLabel';

////// sample cell model ///////
//const headCells = [
//   {
//     id: 'factoryName',
//     numeric: false,
//     headCellAlign: 1,
//     tableCellAlign: 2,
//     disablePadding: false,
//     label: 'Outlet'
//   },
// ];

{/* <CustomMaterialTable
                headCells={headCells}
                tableData={tableData}
              /> */}
///////////////////////////////

export const CustomMaterialTable = ({ headCells, tableData }) => {
    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%'
        },
        paper: {
            width: '100%',
            marginBottom: theme.spacing(2)
        },
        table: {
            minWidth: 750
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    }));

    const classes = useStyles();
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('ashPlantain');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }
    function EnhancedTableHead(props) {
        const { classes, order, orderBy, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <TableRow>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.headCellAlign == 1 ? 'center' : headCell.headCellAlign == 2 ? 'left' : 'right'}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }

    EnhancedTableHead.propTypes = {
        classes: PropTypes.object.isRequired,
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, tableData.length - page * rowsPerPage);

    return (
        <>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <Card style={{ justifycontent: 'center', width: '100rem' }}>
                    <Paper className={classes.paper}>
                        <TableContainer>
                            <Table
                                className={classes.table}
                                aria-labelledby="tableTitle"
                                aria-label="enhanced table"
                            >
                                <EnhancedTableHead
                                    classes={classes}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={tableData.length}
                                />
                                <TableBody>
                                    {stableSort(tableData, getComparator(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, index) => {
                                            const labelId = `enhanced-table-checkbox-${index}`;

                                            return (
                                                <TableRow>
                                                    {headCells.map((column) => {
                                                        const value = row[column.id];
                                                        return (
                                                            <TableCell id={labelId} align={column.tableCellAlign == 1 ? 'center' : column.tableCellAlign == 2 ? 'left' : 'right'}>
                                                                {value == undefined ? '-' : column.numeric == true ? parseFloat(value).toFixed(2) : value}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}

                                    {/* {emptyRows > 0 && (
                                        <TableRow style={{ height: 1 * emptyRows }}>
                                            <TableCell align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold" }}>2220</TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold" }}>22810</TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold" }}>4870</TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold" }}>1050</TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold" }}>4750</TableCell>

                                        </TableRow>
                                    )} */}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[5, 50, 100]}
                            component="div"
                            count={tableData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                </Card>
            </Stack>
        </>
    );
}